.container {
  position: relative;
  padding: var(--space-s);

  .spinner {
    display: none;
    position: absolute;
    top: 50%;
    left: var(--space-xs);
    transform: translateY(-50%);
  }
}

.isUpdating {
  .spinner {
    display: block;
  }

  .checkbox {
    opacity: 0;
  }
}
